import type { ColumnDef } from '@tanstack/react-table'

import type { FormattedFeedProductType, PriceSegmentOption } from '@/types'

import { SegmentOfferPriceCell } from './SegmentPriceColumns'
import cn from './SegmentPriceColumns.module.scss'

const SEGMENT_PRICE_COLUMN_PREFIX = 'segmentPrice:'

export const SEGMENT_PRICE_COLUMN_WIDTH = 'minmax(104px, 0.5fr)'

export const isSegmentPriceColumnId = (id: string) =>
  id.startsWith(SEGMENT_PRICE_COLUMN_PREFIX)

export const getSegmentPriceColumns = (
  segments: PriceSegmentOption[]
): ColumnDef<FormattedFeedProductType, unknown>[] =>
  segments.map((segment) => ({
    id: `${SEGMENT_PRICE_COLUMN_PREFIX}${segment.code}`,
    header: () => (
      <span className={cn.header} title={segment.description}>
        {segment.description}
      </span>
    ),
    cell: ({ row }) => (
      <SegmentOfferPriceCell row={row} segmentCode={segment.code} />
    ),
  }))
